// Priorité au fil : les widgets non critiques (anniversaires, verset, suggestions, contacts, directs prévus,
// liste des notifications…) attendent que le fil ait affiché sa première page (ou 2,5 s max) avant de lancer
// leurs requêtes, pour ne pas concurrencer /posts et /stories sur un réseau mobile.
let ready = false;
const queue = [];

export const markFeedReady = () => {
  if (ready) return;
  ready = true;
  queue.splice(0).forEach((fn) => { try { fn(); } catch { /* noop */ } });
};

if (typeof window !== "undefined") setTimeout(markFeedReady, 2500);

// Exécute fn quand le fil est prêt ; renvoie une fonction d'annulation (démontage du composant).
export const whenFeedReady = (fn) => {
  if (ready) { fn(); return () => {}; }
  let cancelled = false;
  const wrapped = () => { if (!cancelled) fn(); };
  queue.push(wrapped);
  return () => { cancelled = true; const i = queue.indexOf(wrapped); if (i >= 0) queue.splice(i, 1); };
};
